import { atom } from 'recoil';
const fileShowState = atom({
  key: 'propsData/fileShow',
  default: false,
});

export { fileShowState };
